import { Subject } from 'rxjs';
import {Observable} from 'rxjs';
import {NotificationItem} from '../models/notification-item';

// this class is the base interface of services used by the aggregated-notification-service for the notification indicator
export abstract class NotificationService {
  notificationStream: Observable<NotificationItem> = new Subject<NotificationItem>();

  abstract type: string;

  constructor(setup: any) {

  }

  abstract markAsRead(items: Array<NotificationItem>): Observable<any>;
  abstract markAsSeen(items: Array<NotificationItem>): Observable<any>;

  abstract initializeNotificationStream(): Observable<any>;

  //This is one of the trickier functions.  It needs to get the right number of notifications that we should show
  //in the UI. But how many is that? These will get aggregated in the Notification indicator controller.
  abstract getRecentNotifications(limit: number): Observable<Array<NotificationItem>>;
}
